import { render } from "./PaletteModules.vue?vue&type=template&id=698b3d81"
import script from "./PaletteModules.vue?vue&type=script&lang=js"
export * from "./PaletteModules.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__